import { render, staticRenderFns } from "./EditPrebuiltSurveys.vue?vue&type=template&id=3dc82b92&"
import script from "./EditPrebuiltSurveys.vue?vue&type=script&lang=ts&"
export * from "./EditPrebuiltSurveys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports